import { Box, Card, Grid, Modal, Typography } from '@mui/material';
import MDButton from 'components/MDButton';

// import { colorScheme } from 'default';
import HelpIcon from '@mui/icons-material/Help';
import Map from 'components/Map/map';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  // border: '2px solid #000',
  boxShadow: 24,
  p: 4,
  display:'grid',
  justifyContent:'center'
};
function DisplayModal({ ...props }) {

  return (
     <Modal
     open={props.open}
     onClose={props.closeModalClick}
     aria-labelledby="modal-modal-title"
     aria-describedby="modal-modal-description"
   >
    <Card sx={style}>
     <Box>
     <Typography id="modal-modal-title" variant="h6" component="h2" style={{fontSize:"40px",textAlign:"center"}}>
       <HelpIcon  style={{color:"red"}}/>
       </Typography>
       <Typography id="modal-modal-title" variant="h6" component="h2" style={{color:"black"}}>
       Are you Sure you want to Finalize this order?
       </Typography>
       <Grid container id="modal-modal-description" sx={{ mt: 2,justifyContent:"center" }}>
       <MDButton color="warning"  onClick={props.handleCancel} style={ {width:"64px",textTransform: "capitalize"}}>
       No
     </MDButton>
     &nbsp; &nbsp;
     <MDButton color="error" onClick={props.handleDelete} style={{width:"64px",textTransform: "capitalize"}}>
       Yes
     </MDButton>
     <Map/>
       </Grid>
     </Box>
     </Card>
   </Modal>
  
  );
}

export default DisplayModal;
